module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "landing-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [(!_vm.hasEntered) ? _c('div', {
    staticClass: "landing",
    attrs: {
      "data-size": "sm"
    }
  }, [(_vm.hasSupport) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "intro-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.houseImage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduction"
  }, [_c('h1', [_vm._v(_vm._s(_vm.landing.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.landing.tagline))])]), _vm._v(" "), _c('div', {
    staticClass: "breakdown-insurance"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [((_vm.aboutContent.about_heading_1 || _vm.aboutContent.about_body_1)) ? _c('section', [(_vm.aboutContent.about_heading_1) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_heading_1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aboutContent.about_body_1) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_body_1)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), ((_vm.aboutContent.about_heading_2 || _vm.aboutContent.about_body_2)) ? _c('section', [(_vm.aboutContent.about_heading_2) ? _c('h3', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_heading_2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aboutContent.about_body_2) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent.about_body_2)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('progress-button', {
    attrs: {
      "method": _vm.openSesames,
      "loadingLabel": _vm.loadingLabel,
      "readyLabel": _vm.buttonLabel
    }
  })], 1)])])]) : _c('div', {
    staticClass: "content unsupported"
  }, [_c('h1', [_vm._v(_vm._s(_vm.unsupported.heading))]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v(_vm._s(_vm.unsupported.msg))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a70ec39","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLanding.vue
// module id = 462
// module chunks = 1